/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
*
* Created on   : 18/02/26
* @author      : Pavithra P
* @since       : 0.0.1
* Requirement# :
* Purpose      : Axios service wrapper for the Manufacturer master-data REST endpoints.
* -----------------------------------------------------------------------------
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE      |   AUTHOR  |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
* 28849          |  28/08/26   |   surya   |  getManufacturerTableData now sends
*                                           |  page/size/sortDir — it previously sent
*                                           |  no params, so the backend's default
*                                           |  page size (10) silently capped every
*                                           |  fetch.
*
*/

import { executeGetData, executePostData, executePutData, executeDeleteData } from "./ApiBase";
import { ConfigUrl } from "../auth/OidcConfig";

export const getManufacturerTableData = async (
  accessToken: any,
  page: number,
  size: number,
  sortDir: 'ASC' | 'DESC' = 'ASC',
) => {
  const url = `${ConfigUrl.baseURL}/manufacturers/allManufacturers?page=${page}&size=${size}&sortDir=${sortDir}`;
  return await executeGetData(url, accessToken);
};

export const editVendor = async (payload: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/manufacturers/update`;
  return await executePutData(url, payload, accessToken);
}

export const getVendorsById = async (id: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/manufacturers/getVendorsById/id/${id}`;
  return await executeGetData(url, accessToken);
};

export const saveVendor = async (vendor: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/manufacturers/saveVendor`;
  return await executePostData(url, vendor, accessToken);
};

export const deleteManufacturer = async (id: any, accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/manufacturers/id/${id}`;
  return await executeDeleteData(url, accessToken);
}